import { deleteArtModelo, getArtModelosPanel,postArtModelo } from "../../services/ArticulosModelosServices";
import { ArticulosModelosContext } from "./ArticulosModelosContext"

export const ArticulosModelosState = ({ children }) => {
    const getArtModelosPanelData = async (searchRam,searchTerm, page, perPage) => {
        let res = await getArtModelosPanel(searchRam,searchTerm, page, perPage)
        return res;
    }

    const deleteArticuloModeloData = async (body) => {
        const res = await deleteArtModelo(body)
        return res
    }

    const postArticuloModeloData = async (body) => {
        const res = await postArtModelo(body)
        return res
    }
    return <ArticulosModelosContext.Provider value={{
        deleteArticuloModeloData,
        getArtModelosPanelData,
        postArticuloModeloData
    }} >
        {children}
    </ArticulosModelosContext.Provider>
}